import { render, staticRenderFns } from "./SKCollapseItem.vue?vue&type=template&id=5cc3a65b&scoped=true&"
import script from "./SKCollapseItem.vue?vue&type=script&lang=js&"
export * from "./SKCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./SKCollapseItem.vue?vue&type=style&index=0&id=5cc3a65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3a65b",
  null
  
)

export default component.exports